export class InstantRestoreOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "promotionWindow",
            "baseName": "promotionWindow",
            "type": "InstantRestorePromotionWindow",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InstantRestoreOptions.attributeTypeMap;
    }
    constructor() {
    }
}
